import React from "react"
import PropTypes from "prop-types"
import moment from 'moment'
import Icon from '../app_components/Icon'
import { semantic } from '@lexody/design-tokens'

class MeetingStatusSection extends React.Component {
  constructor(props) {
    super(props)
  }

  renderBadge(label, variant) {
    return(
      <div className={`upcomingLexCard__statusBadge upcomingLexCard__statusBadge--${variant}`}>
        {variant === 'pending' &&
          <Icon name="hourglass" size={12} color={semantic.warning.text.label} />
        }
        <span>{label}</span>
      </div>
    )
  }

  render() {
    const { meeting_time, accepted, requestor, requestee, status } = this.props.item
    const now = moment()
    const meetingTime = moment(meeting_time)

    if ((status === "Canceled" || status === "Cancelled") || (now.isAfter(meetingTime) && accepted != true) ) {
      return this.renderBadge('CANCELLED', 'cancelled')
    } else if (now.isAfter(meetingTime)) {
      return this.renderBadge('COMPLETE', 'complete')
    }
    else if(accepted === false) {
      if(requestor.id === this.props.currentUser.id) {
        const name = (requestee.nickname != undefined && requestee.nickname.length > 1)
          ? requestee.nickname.toUpperCase()
          : requestee.first_name.toUpperCase()
        return this.renderBadge(`WAITING FOR ${name}'S APPROVAL`, 'pending')
      } else {
        return this.renderBadge('NEEDS YOUR RESPONSE', 'pending')
      }
    }
    return null
  }
}

export default MeetingStatusSection;
